import React from "react"
import {Recognition} from "@irati/types"
import {H2} from "@irati/ui/src/Typography"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {recognitionUsersToStringTitle, recognitionUsersToStringSubtitle} from "@irati/recognition/utils/recognitionUsersToString"
import {injectIntl, InjectIntlProps} from "@irati/utils/lang/injectIntl"
import authentication from "@irati/auth"
import Spacing from "@irati/ui/src/Spacing"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {Bold, EndDate} from "../shared/layouts"
import UsersTooltip from "../../shared/UsersTooltip"
import {ModalHeader} from "../shared/Modal"
import ModeratedMessage from "../../shared/Moderated"
import WhoCreated from "../../WhoCreated"

interface Props extends InjectIntlProps {
  recognition: Recognition
}
const RecognitionDetails: React.FC<Props> = (props) => {
  const {recognition, formatMessage} = props
  const theme = useTheme()
  const users = recognition.receivers.results
  const title = recognitionUsersToStringTitle(users, formatMessage)
  const user = recognition.createdBy || authentication.user()
  const subtitle = recognitionUsersToStringSubtitle(users, recognition.senderName || firstnameLastname(user), formatMessage)

  return (
    <Flex direction="column" justifyContent="center" alignItems="center" height="100%">
      <Spacing marginBottom>
        <ModalHeader users={recognition.receivers.results} singlePictureSize={80} multiplePictureSize={80} />
      </Spacing>
      <H2 textAlign="center" marginBottom>
        <UsersTooltip placement="bottom" users={users}>
          <Bold>{title}</Bold>
        </UsersTooltip>
        <br />
        {subtitle}
      </H2>
      <EndDate endsAt={recognition.createdAt} />
      <Flex direction="column" gap={theme.spacing.two} width="100%">
        <ModeratedMessage message={recognition.message} isModerated={recognition.moderated} />
        <WhoCreated createdBy={recognition.createdBy} senderName={recognition.senderName} />
      </Flex>
    </Flex>
  )
}

export default injectIntl(RecognitionDetails)
